@if (options().length) {
<div class="flex gap-1">
  <ul class="flex flex-wrap -m-1">
    <li class="m-1">
      <button
        type="button"
        class="inline-flex items-center justify-center text-sm font-medium leading-5 rounded-full px-3 py-1 border border-slate-200 dark:border-slate-700 hover:border-slate-300 dark:hover:border-slate-600 shadow-sm dark:bg-slate-800 duration-150 ease-in-out"
        [class]="
          viewAll()
            ? 'ord-bg-indigo text-white'
            : 'bg-white text-slate-500 dark:text-slate-400'
        "
        (click)="onItemSelected(null)"
      >
        View All
      </button>
    </li>

    @for (option of options(); track option.value) {
    <li class="m-1">
      <button
        type="button"
        class="inline-flex items-center justify-center text-sm font-medium leading-5 rounded-full px-3 py-1 border border-slate-200 dark:border-slate-700 hover:border-slate-300 dark:hover:border-slate-600 shadow-sm dark:bg-slate-800 duration-150 ease-in-out"
        [class]="
          value() === option.value
            ? 'ord-bg-indigo text-white'
            : 'bg-white text-slate-500 dark:text-slate-400'
        "
        (click)="onItemSelected(option.value)"
      >
        {{ option.label }}
      </button>
    </li>
    }

    @if (showMoreButton()) {
    <li class="m-1">
      <button
        type="button"
        class="inline-flex items-center justify-center text-sm font-medium leading-5 rounded-full px-3 py-1 border border-slate-200 dark:border-slate-700 hover:border-slate-300 dark:hover:border-slate-600 shadow-sm dark:bg-slate-800 duration-150 ease-in-out"
        [class]="
          moreCategoriesSelected()
            ? 'ord-bg-indigo text-white'
            : 'bg-white text-slate-500 dark:text-slate-400'
        "
        (click)="onMoreCategoriesClick()"
      >
        + More
      </button>
    </li>
    }
  </ul>
</div>
}
